import React from 'react';
import { ReactComponent as NoDataSvg } from '../../assets/no-data.svg';
import './NoDataFound.less';

interface NoDataFoundProps {
  description: string;
}

const NoDataFound: React.FC<NoDataFoundProps> = ({ description }) => {
  return (
    <div id="no-data-found">
      <NoDataSvg />
      <div className="description">{description}</div>
    </div>
  );
};

export default NoDataFound;
